import { useState, useEffect } from 'react';
import { ADMIN_ENDPOINTS, adminFetch } from '../config';
import './Admin.css';

export default function AdminMessages() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = () => {
    adminFetch(ADMIN_ENDPOINTS.fetchMessages)
      .then((r) => r.json())
      .then((data) => {
        if (data.error) setError(data.error);
        else setMessages(Array.isArray(data) ? data : []);
      })
      .catch(() => setError('Failed to load'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await adminFetch(ADMIN_ENDPOINTS.messageMarkRead, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id }),
    });
    setMessages((prev) => prev.map((m) => (m.id === id ? { ...m, is_read: 1 } : m)));
  };

  if (loading) return <p>Loading…</p>;
  if (error) return <p style={{ color: 'var(--admin-danger)' }}>{error}</p>;

  return (
    <>
      <h1>Contact Messages</h1>
      <div className="admin-table-wrap">
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Name</th>
              <th>Email</th>
              <th>Subject</th>
              <th>Read</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {messages.map((m) => (
              <>
                <tr key={m.id} style={!m.is_read ? { background: '#1e2a3a' } : {}}>
                  <td>{m.created_at ? new Date(m.created_at).toLocaleString() : ''}</td>
                  <td>{m.name}</td>
                  <td>{m.email}</td>
                  <td>{m.subject}</td>
                  <td>{m.is_read ? 'Yes' : 'No'}</td>
                  <td>
                    {!m.is_read && (
                      <button type="button" className="btn btn-sm" onClick={() => markRead(m.id)}>Mark read</button>
                    )}
                    <a href={`mailto:${encodeURIComponent(m.email)}?subject=Re: ${encodeURIComponent(m.subject || '')}`} className="btn btn-sm">Reply</a>
                  </td>
                </tr>
                <tr key={`${m.id}-body`}>
                  <td colSpan={6} style={{ paddingLeft: '2rem', color: '#aaa', fontSize: '0.9rem' }}>
                    {m.message?.split('\n').map((line, i) => (
                      <span key={i}>{line}<br /></span>
                    ))}
                  </td>
                </tr>
              </>
            ))}
          </tbody>
        </table>
      </div>
      {messages.length === 0 && <p>No messages yet.</p>}
    </>
  );
}
